<div id="i3-woc-container">
    <div id="i3-woc-wrapper" class="prevent-select">

        <div class="i3-woc-col left">
            <div class="i3-woc-datum top-row">
                <div class="i3-woc-datum-lbl">{{ 'CASE_SENSITIVE.ID' | translate }}</div>
                <div class="i3-woc-datum-value">{{ workOrder.workOrderId }}</div>
            </div>
            <div class="i3-woc-datum">
                <div class="i3-woc-datum-lbl">{{ 'STRINGS.DESCRIPTION' | translate }}</div>
                <div class="i3-woc-datum-value">{{ workOrder.description }}</div>
            </div>
        </div>

        <div class="i3-woc-col right">
            <div class="i3-woc-datum top-row">
                <div class="i3-woc-datum-lbl">{{ 'CASE_SENSITIVE.TIME_ALLOCATED' | translate }}</div>
                <div class="i3-woc-datum-value">{{ workOrder.estimatedTime }} {{ 'STRINGS.HOURS_ABBR' | translate }}</div>
            </div>
            <div class="i3-woc-datum">
                <div class="i3-woc-datum-lbl">{{ 'STRINGS.TASKS' | translate }}</div>
                <div class="i3-woc-datum-value">{{ workOrder.completedCount }}/{{ workOrder.taskCount }}</div>
            </div>
        </div>

    </div>
</div>
